<template>
    <section id="brands-matter">
        <div class="max-w-2xl mx-auto px-6 py-10 md:py-16 text-center text-dark-grey">
            <h2 class="capitalize">Brands Matter.</h2>
            <p class="max-w-md mx-auto">In today's competitive and interconnected world, brands have become more than just a name or a logo. They represent a promise, a reputation, and a set of value that consumers connect with on an emotional level.</p>
        </div>
        <div class="flex flex-wrap w-full">
            <BrandTile v-for="brand in primaryBrands" :key="'p-' + brand.name"
                :brand="brand" size-class="w-1/2 md:w-1/5" />
            <BrandTile v-for="brand in secondaryBrands" :key="'s-' + brand.name"
                :brand="brand" size-class="w-1/2 md:w-1/6" />
        </div>
    </section>
</template>
<script>
import BrandTile from './BrandTile.vue';

export default {
    name: 'BrandsMatter',
    components: {
        BrandTile
    },
    data() {
        return {
            primaryBrands: [
                {
                    name: 'boss',
                    img: '/images/brand-tiles/boss.webp',
                    logo: '/images/logos/boss_frame.svg',
                    to: '/brands/boss'
                },
                {
                    name: 'howard-leight',
                    img: '/images/brand-tiles/howard-leight.webp',
                    logo: '/images/logos/howardleight_frame.svg',
                    to: '/brands/howard-leight'
                },
                {
                    name: 'prosafety',
                    img: '/images/brand-tiles/prosafety.webp',
                    logo: '/images/logos/prosafety_frame.svg',
                    to: '/brands/prosafety'
                },
                {
                    name: 'north',
                    img: '/images/brand-tiles/north.webp',
                    logo: '/images/logos/north_frame.svg',
                    to: '/brands/north'
                },
                {
                    name: 'miller',
                    img: '/images/brand-tiles/miller.webp',
                    logo: '/images/logos/miller_frame.svg',
                    to: '/brands/miller'
                }
            ],
            secondaryBrands: [
                {
                    name: 'uvex',
                    img: '/images/brand-tiles/uvex.webp',
                    logo: '/images/logos/uvex_frame.svg',
                    to: '/brands/uvex'
                },
                {
                    name: 'puma',
                    img: '/images/brand-tiles/puma.webp',
                    logo: '/images/logos/puma_frame.svg',
                    to: '/brands/puma'
                },
                {
                    name: 'hearos',
                    img: '/images/brand-tiles/hearos.webp',
                    logo: '/images/logos/hearos_frame.svg',
                    to: '/brands/hearos'
                },
                {
                    name: 'wcg',
                    img: '/images/brand-tiles/wcg.webp',
                    logo: '/images/logos/wcg_frame.svg',
                    to: '/brands/westcountygardener'
                },
                {
                    name: 'safetyworks',
                    img: '/images/brand-tiles/safetyworks.webp',
                    logo: '/images/logos/safetyworks_frame.svg',
                    to: '/brands/safetyworks'
                },
                {
                    name: 'mud',
                    img: '/images/brand-tiles/mud.webp',
                    logo: '/images/logos/mud_frame.svg',
                    to: '/brands/mud'
                }
            ]
        }
    }
}
</script>